
<div>
    <f-read-only-field
        v-if   = "readonly"
        class  = "w-100 mt-1"
        :dense = "true"
        :label = "label"
        :value = "name"
        color  = "pt-0-5 pl-1 ro-background"
    />

    <f-enum-select
        v-if          = "!readonly"
        v-model       = "objValue"
        :label        = "label"
        :readonly     = "readonly"
        module        = "msd"
        type          = "escGadgetRentType"
        :hide-details = "hideDetails"
        @input        = "onChange"
    />
</div>
